module.exports = __webpack_public_path__ + "img/内容图例_3.f8672d6c.png";